export default __webpack_public_path__ + "static/media/governmentIcon.b7222c53.svg";